import React, { useState } from "react";
import SettingsComponent from "./Settings.Component";
import { Spin } from "antd";

const SettingsContainer = () => {
  const [loading, setLoading] = useState(false);
  return (
    <Spin spinning={loading}>
      <SettingsComponent setLoading={setLoading} />
    </Spin>
  );
};

export default SettingsContainer;
